import {useEffect, useRef, useState} from "react";

export const useContentHeight = () => {
    const [contentHeight, setContentHeight] = useState<number | null>(null);

    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let resizeObserver: null | ResizeObserver = null;

        if ("ResizeObserver" in window) {
            resizeObserver = new ResizeObserver(() => {
                requestAnimationFrame(() => {
                    setContentHeight(contentRef.current?.offsetHeight || 0);
                });
            });

            if (contentRef.current) {
                resizeObserver.observe(contentRef.current);
            }
        }

        return () => {
            if (contentRef.current && resizeObserver) {
                resizeObserver.unobserve(contentRef.current);
            }
        };
    }, [contentRef.current, setContentHeight]);

    return {contentRef, contentHeight};
};
